import { render } from "./Procurement.vue?vue&type=template&id=15afb12e&scoped=true"
import script from "./Procurement.vue?vue&type=script&lang=js"
export * from "./Procurement.vue?vue&type=script&lang=js"

import "./Procurement.vue?vue&type=style&index=0&id=15afb12e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15afb12e"]])

export default __exports__